import {Injectable} from '@angular/core';
@Injectable()
export class MarkerInfoService {

  address?: string;
  iconUrl?: string;
  name?: string;
  position: any;
  shouldCenterOnAdd: boolean;
  shouldOpenInfoOnAdd: boolean;
  setPosition = this.markSetPosition;

  public window = window;

  setMarkerInfo(markName?: string, markAddress?: string, markShouldCenterOnAdd?: boolean, markIconUrl?: string,
                markShouldOpenInfoOnAdd?: boolean, latitude?: unknown, longitude?: unknown){
    this.address = markAddress;
    this.iconUrl = markIconUrl;
    this.name = markName;
    this.position = null;
    this.shouldCenterOnAdd = typeof(markShouldCenterOnAdd) === 'boolean' ? markShouldCenterOnAdd : false;
    this.shouldOpenInfoOnAdd = typeof(markShouldOpenInfoOnAdd) === 'boolean' ? markShouldOpenInfoOnAdd : false;
  }

  markSetPosition(_latitude: any, _longitude: any) {
    if (isNaN(_latitude) || isNaN(_longitude)) return;

    // lat = parseFloat(_latitude, 10);
    const lat = parseFloat(_latitude);
    // lng = parseFloat(_longitude, 10);
    const lng = parseFloat(_longitude);
    this.position = {lat: lat, lng: lng};
  }
}
